import * as React from 'react';
import { styles } from './styles';

interface Props {
  inGroup?: boolean;
  groupFirst?: boolean;
  groupLast?: boolean;
}

export const Row: React.SFC<Props> = ({ children, inGroup, groupFirst, groupLast }) => (
  <>
    <div className={styles.row(inGroup, groupFirst, groupLast)}>{children}</div>
    {inGroup && !groupLast ? <span className={styles.groupBreak} /> : null}
  </>
);
